__turbopack_context__.v({
  "expand-arrow": "GraphCardWithTitle-module-scss-module__IyDvea__expand-arrow",
  "open": "GraphCardWithTitle-module-scss-module__IyDvea__open",
});
